var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from 'react';
var convert = function (value, sign, _a) {
    if (value === void 0) { value = 0; }
    if (sign === void 0) { sign = ''; }
    var _b = _a === void 0 ? {} : _a, _c = _b.digits, digits = _c === void 0 ? 2 : _c, _d = _b.d, d = _d === void 0 ? '-' : _d;
    var num = !value
        ? d
        : value.toLocaleString('de-DE', { minimumFractionDigits: digits });
    return "" + num + (sign ? " " + sign : '');
};
var Decimal = /** @class */ (function (_super) {
    __extends(Decimal, _super);
    function Decimal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Decimal.prototype.render = function () {
        var _a = this.props, _b = _a.value, value = _b === void 0 ? 0 : _b, digits = _a.digits, d = _a.d, sign = _a.sign;
        return convert(value, sign, { digits: digits, d: d });
    };
    Decimal.from = convert;
    return Decimal;
}(Component));
export default Decimal;
//# sourceMappingURL=decimal.js.map